<div class="login-container">
  <mat-spinner *ngIf="_loaderShow" class="tp-margin">
  </mat-spinner>
  <div>
    <!-- <img class="wave" src="../../../assets/images/wave_blue.png"> -->
    <div class="container">
      <!-- <div class="img">
          <img src="../../../assets/images/bg_new.svg">
        </div> -->
      <div class="login-content">
        <form [formGroup]="loginForm" *ngIf="loginForm">
          <h3 class="product-sign-in-text">Sign In To Your Account {{donation}}</h3>
          <p class="login-error-msg" *ngIf="showError">Invalid Username or Password</p>
          <p class="login-error-msg" *ngIf="showForgetPasswordMsg">{{validationMsg}}</p>
          <div class="input-div one">
            <div class="i">
              <i class="fas fa-user"></i>
            </div>
            <div class="div">
              <input type="text" placeholder="Username" class="input" formControlName="email">
              <hcn-validation-error [formControl]="loginForm.get('email')" [validationErrors]="validationErrors.email"
                  [isFormSubmitted]="isFormSubmitted"></hcn-validation-error>
            </div>
          </div>
          <div class="input-div pass">
            <div class="i">
              <i class="fas fa-lock"></i>
            </div>
            <div class="div">
              <input [type]="hide ? 'password' : 'text'" placeholder="Password" class="input"
                formControlName="password">
              <hcn-validation-error [formControl]="loginForm.get('password')"
                  [validationErrors]="validationErrors.password"
                  [isFormSubmitted]="isFormSubmitted"></hcn-validation-error>
            </div>
          </div>
          <div>
            <span style="float: left;">
              <mat-checkbox color="primary" [(ngModel)]="hide"
                (change)="showHidePass()"> &nbsp;&nbsp;&nbsp;&nbsp;Show
                Password</mat-checkbox></span>
          </div>
          <span>
            <button style="margin-top: 25px" class="btn" (click)="login()">Sign In</button>
            <button class="btn btn-sm btn-signup" (click)="singUp()" style="background-color: #da0000">Sign Up</button>
          </span>
          <a style="display: flex; justify-content: space-around;" (click)="forgetPassword()">Forgot Password?</a>
        </form>
      </div>
    </div>
  </div>
</div>